import axios from 'axios';

export { makeUrl } from '@modules/utils';
export { getChannels } from '@modules/api/tv-guide';


/**
 * Returns API response data and set request status if errors
 *
 * @param {object} response The API response object
 * @param {object} context A context object with `progress`, `errors` and `busy` properties
 *
 * @returns The response data or null on error
 */
export function requestStatus(response, context = null)
{
    if (context) {
        context.busy = false;

        if (response.errors) {
            Object.assign(context.errors, response.errors.data || {});
            context.errors.message = response.errors.message;

            return null;
        }
    }

    return response.data;
}

/**
 * Update `progress`, `errors` and `busy` state of provided API context
 *
 * @param {object} context A context object with `progress`, `errors` and `busy` properties
 */
export function updateRequestContext(context)
{
    context.busy = true;
    Object.assign(context.errors, {});
    // context.progress = ...
}


// axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Fetch an HTTP resource(s)
 *
 * @param {string} uri
 * @param {object} options
 *
 * @returns {promise}
 */
export async function get(url, options = {})
{
    return await axios.get(url, options)
        .then((response) => response);
}

/**
 * Create an HTTP resource(s)
 *
 * @param {string} uri
 * @param {object} options
 *
 * @returns {promise}
 */
export async function post(url, data, options = {})
{
    return await axios.post(url, data, options)
        .then((response) => response);
}
